import Vue from "vue";
import vuetify from "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";
import axios from "axios";

Vue.config.productionTip = false;

console.log("Vue version", Vue.version);

// Глобальная примесь
Vue.mixin({
  computed: {
    token() {
      return this.$store.state.token;
    }
  }
});

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App),
  created() {
    axios.interceptors.response.use(response => {
      console.log("axios.interceptors.response", response);
      if (!response.data.success) {
        // Здесь должна быть обработка общих ошибок
        switch (response.data.error) {
          case "AUTH_FAILED":
            this.$root.$emit("notify", response.data.message, "red");
            return response.data;
          case "ACCESS_DENIED":
          case "FATAL_ERROR":
          case "UNKNOWN_ERROR":
            console.error(response.data);
            return response.data;
          case "ERROR":
            this.$root.$emit("notify", response.data.message, "red");
            return response.data;
          case "AUTH_REQUIRED":
            this.$root.$emit(
              "notify",
              `[${response.data.error}] ${response.data.message}`,
              "red"
            );
            router.push({ name: "login" });
            return response.data;
          default:
            return response.data;
        }
      }
      // Если нет ошибок в ответе
      return response.data;
    });
    axios.interceptors.request.use(
      request => {
        request.data.lang = this.$store.getters.getLocale;
        return request;
      },
      error => {
        console.log("axios.interceptors.request.error", error);
      }
    );
  }
}).$mount("#app");
